import { render, staticRenderFns } from "./partnerProductAccountPeriodDetail.vue?vue&type=template&id=07dd932a&scoped=true&"
import script from "./partnerProductAccountPeriodDetail.vue?vue&type=script&lang=js&"
export * from "./partnerProductAccountPeriodDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07dd932a",
  null
  
)

export default component.exports